var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGigabytesIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 42 22",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h42v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M15.01 18.3c2.02 0 3.36-.84 3.98-1.74l.2 1.44h2.56v-7.58h-7.22v2.68h4.26c-.18.8-1.16 2.32-3.5 2.32-2.3 0-4.26-1.54-4.26-4.5 0-3.16 2.26-4.44 4.18-4.44 2.36 0 3.3 1.6 3.52 2.48l3.04-1.06c-.62-1.98-2.5-4.38-6.56-4.38-4 0-7.38 2.94-7.38 7.4 0 4.48 3.24 7.38 7.18 7.38zm15.12-.3c2.68 0 4.44-1.7 4.44-4.02 0-1.84-1.24-3.02-2.52-3.32 1.16-.38 2.08-1.58 2.08-3.04 0-2.18-1.62-3.8-4.42-3.8h-5.3V18h5.72zm-.92-8.5h-1.72V6.44h1.68c1.24 0 1.86.6 1.86 1.52 0 .96-.72 1.54-1.82 1.54zm.26 5.92h-1.98V12.1h1.98c1.24 0 1.96.68 1.96 1.66 0 1.02-.74 1.66-1.96 1.66z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGigabytesIcon);
export default __webpack_public_path__ + "static/media/gigabytes-icon.695e42ad33f825b037c72c8e2d0cb484.svg";
export { ForwardRef as ReactComponent };